import { IsString } from 'class-validator';

export class EmailPasswordDto {
  @IsString()
  readonly emailAddress: string;
  @IsString()
  readonly password: string;
}
